// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".bd0f5bfdede8e5f6ebf683b2598978abd0290483.chunk.bundle.js";
};